<template>
  <div class="about">
    <v-alert icon="mdi-information" colored-border border="left" class="pa-2 my-2 bg-notif" color="warning">
      Silahkan <strong>melengkapi</strong> Laporan IHT berikut berdasarkan batas waktu yang telah ditentukan.
    </v-alert>
    <v-row dense class="pa-4 white--text mb-4 mt-3" style="background-color: #39C57B; margin: 0 1px">
      <v-col cols="12" lg="7" class="my-auto">
        <div class="body-1"> Pilih sekolah untuk <strong>Laporan Pelaksanaan IHT</strong> </div>
      </v-col>
      <v-col cols="12" lg="5" class="text-right">
        <v-menu>
          <template v-slot:activator="{ attrs, on }">
            <v-btn depressed style="background-color: #FDFFCF; border-radius: 5pt" v-bind="attrs" v-on="on">
              <v-row dense>
                <v-col cols="10" class="text-left">
                  <p class="black--text my-auto">
                    {{ sekolah.nama || '-' }}
                  </p>
                </v-col>
                <v-col cols="2" class="my-auto">
                  <v-icon right dark>mdi-chevron-down</v-icon>
                </v-col>
              </v-row>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group v-model="sekolahId" color="primary">
              <template v-for="(sekolah, key) in sekolahs">
                <v-divider v-if="key !== 0" :key="`divider-${key}`"></v-divider>
                <v-list-item :key="key" :value="sekolah.sekolah_id" link>
                  <v-list-item-title>{{ sekolah.nama }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-card tile flat class="my-5">
      <v-list flat>
        <v-list-item>
          <v-list-item-content class="subtitle-1"> Dokumen yang harus dilengkapi </v-list-item-content>
        </v-list-item>
        <template v-for="(laporan, key) in laporans">
          <div :key="key">
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon class="pa-0 ma-0 mr-1 my-auto">
                <v-icon size="40" color="info">mdi-file-document</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-row no-gutters>
                  <v-col cols="12" md="4" class="my-auto">
                    <span class="subtitle-1">
                      <b>{{ laporan.nama }}</b>
                    </span>
                  </v-col>
                  <v-col cols="12" md="3">
                    &nbsp;
                    <!--<div class="grey&#45;&#45;text mb-1"><small>Batas Waktu Pelaporan</small></div>-->
                    <!--{{ $localDate($getDeepObj(meta, `wkt_tutup.${laporan.id}`)) }}-->
                  </v-col>
                  <v-col cols="12" md="2">
                    <div class="grey--text mb-1"><small>Status</small></div>
                    <v-chip
                      :class="
                        `${
                          laporan.tidakLapor
                            ? 'orange'
                            : $getDeepObj(monev, `${laporan.id}.k_verval_psp`) > 1
                            ? 'green'
                            : $getDeepObj(monev, `${laporan.id}.is_lengkap`)
                            ? 'blue'
                            : 'grey'
                        } white--text`
                      "
                      small
                    >
                      {{
                        laporan.tidakLapor
                          ? 'Tidak Ada'
                          : $getDeepObj(monev, `${laporan.id}.k_verval_psp`) > 1
                          ? 'Dikirim'
                          : $getDeepObj(monev, `${laporan.id}.is_lengkap`)
                          ? 'Dilengkapi'
                          : 'Belum dilengkapi'
                      }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="grey--text mb-1"><small>Aksi</small></div>
                    <template v-if="Number($getDeepObj(monev, `${laporan.id}.k_verval_psp`)) > 1">
                      <v-btn
                        depressed
                        small
                        :disabled="laporan.disabled"
                        class="orange white--text mr-1 mb-1"
                        @click="onBatalKirim(laporan)"
                      >
                        Batal Laporan
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                        v-if="!laporan.children"
                        depressed
                        small
                        color="info"
                        class="mr-1 mb-1"
                        :disabled="laporan.disabled"
                        @click="onLaporan(laporan)"
                      >
                        {{ monev && monev[laporan.id] ? 'Ubah' : 'Isi' }} Laporan
                      </v-btn>
                      <v-btn
                        depressed
                        small
                        color="success"
                        class="mb-1"
                        @click="onKirim(laporan)"
                        :disabled="!$getDeepObj(monev, `${laporan.id}.is_lengkap`) || laporan.disabled"
                      >
                        Kirim Laporan
                      </v-btn>
                    </template>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <template v-if="laporan.children">
              <template v-for="(child, keyChild) in laporan.children">
                <v-list-item :key="`${key}_${keyChild}`">
                  <v-list-item-icon class="pa-0 ma-0 mr-1 my-auto">
                    <v-icon size="40" color="white">mdi-file-document</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-row no-gutters>
                      <v-col cols="12" md="7" class="my-auto">
                        <div class="grey--text mb-1">
                          <small>Sub {{ laporan.nama }}</small>
                        </div>
                        <span class="subtitle-1">
                          <b>{{ child.nama }}</b>
                        </span>
                        <div v-if="child.desc">
                          <small>
                            <em class="orange--text">{{ child.desc }}</em>
                          </small>
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <div class="grey--text mb-1"><small>Status Laporan</small></div>
                        <v-chip :class="child.tidakLapor ? 'orange' : child.status ? 'success' : 'grey'" small dark>
                          {{ child.tidakLapor ? 'Tidak Ada' : child.status ? 'Sudah Dilengkapi' : 'Belum Dilengkapi' }}
                        </v-chip>
                      </v-col>
                      <v-col v-if="Number($getDeepObj(monev, `${laporan.id}.k_verval_psp`)) < 2" cols="12" md="3">
                        <div class="grey--text mb-1"><small>Aksi</small></div>
                        <v-btn
                          depressed
                          small
                          color="info"
                          class="mr-1 mb-1"
                          :disabled="child.disabled || laporan.disabled"
                          @click="onLaporan(laporan, child)"
                        >
                          {{ child.status ? 'Ubah Laporan' : 'Lengkapi' }}
                        </v-btn>
                      </v-col>
                      <v-col v-else-if="child.view" cols="12" md="3">
                        <div class="grey--text mb-1"><small>Aksi</small></div>
                        <v-btn
                          outlined
                          depressed
                          small
                          color="info"
                          class="mr-1 mb-1"
                          @click="onViewLaporan(laporan, child)"
                        >
                          Lihat Laporan
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
          </div>
        </template>
      </v-list>
    </v-card>
    <base-modal-full
      ref="modal"
      :title="formulir['title']"
      :mode="formulir['mode']"
      :auto-close="formulir['auto-close']"
      @close="onClose"
      @save="onSave"
    >
      <component
        ref="formulir"
        :is="formulir['form']"
        :id="formulir['id']"
        :title="formulir['title']"
        :childId="formulir['childId']"
        :detail="formulir['detail']"
        :mode="formulir['mode']"
        :readOnly="formulir['mode'] === 'detail'"
        :initValue="formulir['init']"
        :type="formulir['type']"
        :masters="masters"
        :mapels="mapel[sekolahId || sekolahAktif.sekolah_id]"
        :kasek="kasek"
        :meta="meta"
      ></component>
    </base-modal-full>
  </div>
</template>
<script>
import Instrumen from './instrumen';
import Laporan from './laporan';
import FormLaporan from './Form';
import FormPartisipan from './formulir/Partisipan';
import FormPartisipanUjian from './formulir/PartisipanUjian';
import FormEvaluasi from './formulir/Evaluasi';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'LaporanIht',
  components: { FormLaporan, FormPartisipan, FormPartisipanUjian, FormEvaluasi },
  mixins: [Instrumen, Laporan],
  data() {
    return {
      formulir: {},
      sekolahId: null,
      session: null,
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('iht', {
      monev: (state) => state.monev,
      meta: (state) => state.meta,
      mapel: (state) => state.mapel,
    }),

    ...mapState('preferensi', {
      ptk: (state) => state?.data?.ptk ?? {},
      kasek: (state) => state?.data?.kasek_monev ?? {},
    }),

    sekolahs() {
      return (this.meta.pelaksana || []).map((pelaksana) => {
        return pelaksana.sekolah;
      });
    },

    sekolahAktif() {
      return this.$getDeepObj(this.meta, 'pelaksana_aktif.sekolah') || {};
    },

    sekolah() {
      const sekolahs = this.sekolahs.filter((sekolah) => +sekolah.sekolah_id === +this.sekolahId);
      if (!this.sekolahId) {
        return this.sekolahAktif;
      }

      return sekolahs[0] || {};
    },

    laporans() {
      if (!this.$isObject(this.meta)) {
        return [];
      }

      const versiLaporan = {
        1: 'laporanVer1',
        2: 'laporanVer2',
        3: 'laporanVer3',
      };

      let laporan = versiLaporan[this.meta.versi_instrumen];
      if (laporan === 'laporanVer3' && this.isSmkPk) {
        laporan = 'laporanVer3Smk';
      }

      return this[laporan];
    },

    isSmkPk() {
      const diklatSekolah = this.$getDeepObj(this.meta, 'pelaksana_aktif') || {};
      return Number(this.$getDeepObj(diklatSekolah, 'sekolah.k_jenjang')) === 5;
    },
  },
  created() {
    this.getMasters(['monev_moda_psp;monev_alasan_psp;pegawai;jenis_ptk|value:jenis_ptk'].join(';'));
    this.fetch({ reset: true }).then(() => {
      if (!this.sekolahId) {
        this.mapels({ id: this.sekolahAktif.sekolah_id });
        this.sekolahId = this.sekolahAktif.sekolah_id;
      }
    });
  },
  methods: {
    ...mapActions('iht', ['fetch', 'fetchInstrumen', 'fetchPartisipan', 'mapels', 'actions', 'detail', 'save']),
    ...mapActions('master', ['getMasters']),
    ...mapActions('preferensi', ['getOnline']),

    async getPspMonev() {
      if (!this.$isObject(this.monev[this.formulir.id])) {
        return Promise.resolve({});
      }

      return await this.detail({ id: this.$getDeepObj(this.monev, `${this.formulir.id}.psp_monev_id`) });
    },

    async getPspPeserta() {
      const { data } = await this.detail({ id: 'guru' });
      return data;
    },

    onViewLaporan(laporan, child = {}) {
      this.onLaporan(laporan, child, 'detail');
    },

    async onLaporan(laporan, child = {}, mode = 'form') {
      if (child.type === 'partisipan') {
        await this.onPartisipan(laporan, child, mode);
        return;
      }

      if (child.type === 'partisipan-ujian') {
        await this.onPartisipanUjian(laporan, child, mode);
        return;
      }

      if (['evaluasi-pelaksanaan', 'evaluasi-pip'].includes(child.type)) {
        await this.onEvaluasi(laporan, child, mode);
        return;
      }

      this.$set(this.formulir, 'mode', mode);
      this.$set(this.formulir, 'form', 'FormLaporan');
      this.$set(this.formulir, 'auto-close', false);
      this.$set(this.formulir, 'title', `${mode === 'detail' ? 'Detail' : 'Formulir'} ${laporan.nama}`);
      this.$set(this.formulir, 'id', laporan.id || '');
      this.$set(this.formulir, 'childId', laporan.children ? child.id : false);
      this.$set(this.formulir, 'type', (child && child.type) || 'umum');
      this.$set(this.formulir, 'init', null);

      const pspMonev = await this.getPspMonev();
      let pesertas = [];

      if (child && child.type === 'peserta') {
        pesertas = await this.getPspPeserta();
      }

      const sekolah = this.$getDeepObj(this.meta, 'pelaksana_aktif.sekolah') || {};
      const detail = Object.assign({}, { kasek: this.kasek }, { ptk: this.ptk }, { pesertas }, pspMonev, { sekolah });

      if (pspMonev) {
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();

          this.$set(this.formulir, 'init', pspMonev);
          this.$set(this.formulir, 'detail', detail);

          clearInterval(this.session);
          this.setIntervalSession();
        });
      }
    },

    async onPartisipan(laporan, child = {}, mode = 'form') {
      this.$set(this.formulir, 'mode', mode);
      this.$set(this.formulir, 'form', 'FormPartisipan');
      this.$set(this.formulir, 'auto-close', false);
      this.$set(this.formulir, 'title', `${mode === 'form' ? 'Formulir' : 'Detail'} Data Sasaran dan Pengajar IHT`);
      this.$set(this.formulir, 'id', laporan.id || '');
      this.$set(this.formulir, 'childId', laporan.children ? child.id : false);
      this.$set(this.formulir, 'type', (child && child.type) || '');

      const pspMonev = await this.getPspMonev();
      this.$set(this.formulir, 'init', pspMonev);

      if (pspMonev) {
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();

          clearInterval(this.session);
          this.setIntervalSession();
        });
      }
    },

    async onPartisipanUjian(laporan, child = {}, mode = 'form') {
      this.$set(this.formulir, 'mode', mode);
      this.$set(this.formulir, 'form', 'FormPartisipanUjian');
      this.$set(this.formulir, 'auto-close', false);
      this.$set(this.formulir, 'title', `${mode === 'form' ? 'Formulir' : 'Detail'} Nilai Pretest dan Posttest`);
      this.$set(this.formulir, 'id', laporan.id || '');
      this.$set(this.formulir, 'childId', laporan.children ? child.id : false);
      this.$set(this.formulir, 'type', (child && child.type) || '');

      const pspMonev = await this.fetchPartisipan({
        type: 'kandidat-ujian',
        params: { k_monev_laporan_psp: 8, sekolah_id: this.sekolahId },
      });

      this.$set(this.formulir, 'init', pspMonev);

      if (pspMonev) {
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
        });
      }
    },

    async onEvaluasi(laporan, child = {}, mode = 'form') {
      this.$set(this.formulir, 'mode', mode);
      this.$set(this.formulir, 'form', 'FormEvaluasi');
      this.$set(this.formulir, 'auto-close', false);
      this.$set(this.formulir, 'id', laporan.id || '');
      this.$set(this.formulir, 'childId', laporan.children ? child.id : false);
      this.$set(this.formulir, 'type', (child && child.type) || '');
      this.$set(
        this.formulir,
        'title',
        `${mode === 'form' ? 'Formulir' : 'Detail'} Evaluasi ${
          child.type === 'evaluasi-pip' ? 'PIP IHT' : 'Pelaksanaan IHT'
        }`
      );

      await this.fetchInstrumen();

      const pspMonev = await this.getPspMonev();
      this.$set(this.formulir, 'init', pspMonev);

      if (pspMonev) {
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();

          // clearInterval(this.session);
          // this.setIntervalSession();
        });
      }
    },

    setIntervalSession() {
      this.session = setInterval(() => {
        this.$store.commit('SET_AUTOSAVE', true);
        this.getOnline().then(() => {
          this.$store.commit('SET_AUTOSAVE', false);
        });
      }, 5 * 60 * 1000);
    },

    getMessage(data) {
      return [
        '<div class="pa-3 grey lighten-3 v-list-item theme--light mt-2">',
        '<div class="v-list-item__icon pa-0 ma-0 mr-1 my-auto">',
        '<i class="v-icon notranslate mdi mdi-file-document theme--light info--text" style="font-size: 40px;"></i>',
        '</div>',
        '<div class="v-list-item__content">',
        '<div class="row no-gutters">',
        '<div class="my-auto col-12">',
        `<span class="subtitle-1"><b>${data.nama}</b></span>`,
        '</div>',
        '</div>',
        '</div>',
        '</div>',
      ].join('');
    },

    onReload() {
      const params = { sekolah_id: this.sekolahId };
      this.fetch({ reset: true, params }).then(() => {
        this.mapels({ id: this.sekolahId });
      });
    },

    onChangeSekolah() {
      if (this.sekolahAktif.sekolah_id === this.sekolahId || !this.sekolahId) {
        this.sekolahId = this.sekolahAktif.sekolah_id;
        return;
      }

      this.onReload();
    },

    onKirim(laporan) {
      const id = this.$getDeepObj(this.monev, `${laporan.id}.psp_monev_id`) || '';
      const type = 'ajuan';
      const message = '<h3>Anda yakin ingin mengajukan Laporan IHT berikut?</h3>' + this.getMessage(laporan);

      this.$confirm(message, `Ajuan Laporan IHT`, {
        tipe: 'success',
      }).then(() => {
        this.actions({ id, type }).then(() => {
          this.$success(`Laporan IHT berhasil diajukan`);

          if (laporan.id === 7 && this.isSmkPk) {
            this.fetchPartisipan({
              type: 'kandidat-ujian',
              params: { k_monev_laporan_psp: 8, sekolah_id: this.sekolahId },
            }).then(() => {
              this.onReload();
            });
          } else {
            this.onReload();
          }
        });
      });
    },

    onBatalKirim(laporan) {
      const id = this.$getDeepObj(this.monev, `${laporan.id}.psp_monev_id`) || '';
      const type = 'batal-ajuan';
      const message = '<h3>Anda yakin ingin membatalkan pengajuan Laporan IHT berikut?</h3>' + this.getMessage(laporan);

      this.$confirm(message, `Batal Ajuan Laporan IHT`, {
        tipe: 'warning',
      }).then(() => {
        this.actions({ id, type }).then(() => {
          this.$success(`Ajuan Laporan IHT berhasil dibatalkan`);
          this.onReload();
        });
      });
    },

    onClose() {
      clearInterval(this.session);
      this.$store.commit('SET_AUTOSAVE', false);
      this.$refs.modal.dialog = false;
    },

    onSave() {
      let formulir = Object.assign({}, this.$refs.formulir.getValue());
      const id = formulir.id;
      const type = this.formulir.type || null;
      let params = new FormData();

      if (type && ['peserta', 'feedback'].includes(type)) formulir.params = formulir.params[type];
      if (type && type === 'administrasi') {
        const files = ['file_konsumsi', 'file_presensi'];
        let temp = {};
        files.forEach((item) => {
          if (formulir.params[item]) {
            this.$set(temp, item, formulir.params[item]);
          }
        });
        formulir.params = temp;
      }

      for (const key in formulir.params) {
        if (this.$isObject(formulir.params[key])) {
          const obj = formulir.params[key];
          Object.keys(obj).forEach((item) => {
            params.append(`${type}s[${key}][${item}]`, formulir.params[key][item] || '');
          });
        } else {
          params.append(key, !formulir.params[key] && formulir.params[key] !== 0 ? '' : formulir.params[key]);
        }
      }

      if (type && type === 'umum') {
        this.onSaveUmum();
        return;
      }

      if (type && type === 'partisipan') {
        this.onSavePartisipan();
        return;
      }

      if (type && type === 'partisipan-ujian') {
        this.onSavePartisipanUjian();
        return;
      }

      if (['evaluasi-pelaksanaan', 'evaluasi-pip'].includes(type)) {
        this.onSaveEvaluasi();
        return;
      }

      if (type === 'feedback') {
        // param feedback
        params = new FormData();
        let id = 0;
        for (const kMonevFeedback in formulir.feedback) {
          const monevFeedback = formulir.feedback[kMonevFeedback] || {};
          params.append(`feedbacks[${id}][k_monev_feedback_psp]`, kMonevFeedback);
          for (let i = 1; i <= 4; i++) {
            const opsi = `n${i}`;
            if (monevFeedback[`${opsi}`] || monevFeedback[`${opsi}`] === 0) {
              params.append(`feedbacks[${id}][${opsi}]`, monevFeedback[`${opsi}`]);
            } else {
              params.append(`feedbacks[${id}][${opsi}]`, '');
            }
          }

          id += 1;
        }
      }

      let error = '';
      const files = ['file_dok1', 'file_dok2', 'file_dok3', 'file_konsumsi', 'file_presensi'];
      for (let key in formulir.params) {
        if (files.includes(key)) {
          if (!error) {
            error = this.$refs.formulir.getErrorMsg(key);
          }
        }
      }

      if (error) {
        this.$error(error);
        this.$refs.modal.loading = false;
        return;
      }

      // tambah param sekolah_id
      params.append('sekolah_id', this.sekolahId);

      this.$store.commit('SET_AUTOSAVE', false);
      this.save({ id, params, type })
        .then(() => {
          this.$success('Data peserta berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.onReload();

          clearInterval(this.session);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSaveUmum() {
      const id = this.formulir.id;
      const type = this.formulir.type || null;
      const formulir = Object.assign({}, this.$refs.formulir.getValue());
      let params = Object.assign({ sekolah_id: this.sekolahId }, formulir.params || {});

      // update param berkas
      params.berkases = params.berkases.filter((berkas) => !!berkas.file_berkas);
      if (!params.berkases.length) {
        delete params.berkases;
      }

      this.$store.commit('SET_AUTOSAVE', false);
      this.save({ id, params, type })
        .then(() => {
          this.$success('Data peserta berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.onReload();

          clearInterval(this.session);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSavePartisipan() {
      const id = this.$getDeepObj(this.formulir, 'init.psp_monev_id') || '';
      const type = 'partisipan';
      const params = { partisipans: this.$refs.formulir.getValue() };

      this.$store.commit('SET_AUTOSAVE', false);
      this.save({ id, params, type })
        .then(() => {
          this.$success(`Data Sasaran dan Pengahar IHT berhasil disimpan`);
          this.$refs.modal.dialog = false;
          this.onReload();

          clearInterval(this.session);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSavePartisipanUjian() {
      const type = 'update-ujian';
      const params = { k_monev_laporan_psp: 8, sekolah_id: this.sekolahId, ujians: this.$refs.formulir.getValue() };

      this.save({ params, type })
        .then(() => {
          this.$success(`Data nilai Pretest dan Posttest berhasil disimpan`);
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSaveEvaluasi() {
      const id = this.$getDeepObj(this.formulir, 'init.psp_monev_id') || '';
      const type = this.$getDeepObj(this.formulir, 'type') || '';
      const values = this.$refs.formulir.getValue();
      const params = Object.assign({}, { k_monev_laporan_psp: 8, sekolah_id: this.sekolahId }, values);

      this.save({ id, params, type })
        .then(() => {
          this.$success(`Data Sasaran dan Pengahar IHT berhasil disimpan`);
          this.$refs.modal.dialog = false;
          this.onReload();

          clearInterval(this.session);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
  watch: {
    sekolahId: 'onChangeSekolah',
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
